import { Component } from '@angular/core';
import { Platform, IonicPage, NavController, NavParams, LoadingController, AlertController, ActionSheetController, Events } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';

import { User } from '../../models/user.model';

import { AuthProvider } from "../../providers/auth/auth";

import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-profile-avatar',
  templateUrl: 'profile-avatar.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ProfileAvatarPage {

  user: User;
  picture: string;
  err: string;
  loading: boolean;

  constructor(public platform: Platform, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public events: Events, public actionSheetCtrl: ActionSheetController, private camera: Camera, public authProvider: AuthProvider) {
    this.picture = '';
  }

  getProfile() {
    this.loading = true;
    this.authProvider.profile()
      .subscribe(
        user => this.user = new User(user),
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  getBase64Image(imageData: string) {
    return `data:image/jpeg;base64,${imageData}`;
  }

  selectPicture() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('ACTION_SHEETS_PICTURE_TITLE'),
      buttons: [
        {
          text: this.translate.instant('ACTION_SHEETS_TAKE_PICTURE'),
          icon: !this.platform.is('ios') ? 'camera' : null,
          handler: () => {
            this.takePicture();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_OPEN_LIBRARY'),
          icon: !this.platform.is('ios') ? 'images' : null,
          handler: () => {
            this.openLibrary();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_CANCEL'),
          role: 'cancel',
          icon: !this.platform.is('ios') ? 'close' : null
        }
      ]
    });
    actionSheet.present();
  }

  openLibrary() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    };

    this.camera.getPicture(options).then((imageData) => {
      this.picture = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  takePicture() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: this.camera.Direction.FRONT
    };

    this.camera.getPicture(options).then((imageData) => {
      this.picture = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  canSend() {
    return (this.picture);
  }

  send() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      picture: this.picture
    };

    this.authProvider.uploadAvatar(values)
      .subscribe(
        data => {
          this.events.publish('profile:refresh')
        },
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_AVATAR_UPLOAD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_AVATAR_UPLOAD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
          this.navCtrl.pop();
        }
      );
  }

  ionViewDidLoad() {
    this.getProfile();
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile-avatar/profile-avatar.ts